import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';
import { queryKeys } from './queryKeys';
import type { IntegrationsStatus } from '../types';

export function useIntegrations() {
  return useQuery({
    queryKey: queryKeys.integrations(),
    queryFn: () => apiFetch<IntegrationsStatus>('/api/v1/integrations/status'),
  });
}
